<template>
  <async-btn
    :task="task"
    icon="fa fa-undo"
    title="Restore post"
    v-bind="$attrs"
    @click="restore"
  />
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { ReportPost } from '@/type';
import AsyncBtn from '@/components/AsyncBtn.vue';
import { restore } from './report-post';

interface Data {
  task: Promise<ReportPost>|null,
}

export default defineComponent({
  emits: ['restored'],
  components: { AsyncBtn },
  props: {
    reportPost: {
      type: Object as () => ReportPost,
      required: true,
    },
  },
  data(): Data {
    return {
      task: null,
    };
  },
  methods: {
    restore() {
      this.task = restore(this.reportPost);
      this.task.then((reportPost: ReportPost) => {
        this.$emit('restored', reportPost);
      });
    },
  },
});
</script>
